/**
 * Get Alerts Use Case
 * Fetches alerts summary and list
 */

import { DashboardRepository } from '../data/dashboard-repository';
import { AlertSummary, Alert } from '../types/dashboard-types';
import { AlertFilters } from '../types/filter-types';

export class GetAlertsUseCase {
  constructor(private readonly repository: DashboardRepository) {}

  async executeSummary(): Promise<{
    summary: AlertSummary;
    hasError: boolean;
    errorMessage?: string;
  }> {
    try {
      const summary = await this.repository.getAlertsSummary();

      return {
        summary,
        hasError: false,
      };
    } catch (error) {
      console.error('GetAlertsUseCase.executeSummary failed:', error);

      return {
        summary: this.getEmptySummary(),
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to load alerts summary',
      };
    }
  }

  async executeList(filters?: AlertFilters): Promise<{
    alerts: Alert[];
    totalCount: number;
    hasError: boolean;
    errorMessage?: string;
  }> {
    try {
      const result = await this.repository.getAlerts(filters);

      return {
        alerts: result.alerts,
        totalCount: result.totalCount,
        hasError: false,
      };
    } catch (error) {
      console.error('GetAlertsUseCase.executeList failed:', error);

      return {
        alerts: [],
        totalCount: 0,
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to load alerts',
      };
    }
  }

  private getEmptySummary(): AlertSummary {
    return {
      totalActive: 0,
      criticalCount: 0,
      warningCount: 0,
      infoCount: 0,
      connectivityIssues: 0,
      failedCalculations: 0,
      failedPayments: 0,
    };
  }
}
